import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Card } from "antd";
import { connect } from "react-redux";

import LivechatLog from "./livechatLog/index";
import BroadcastLog from "./broadcastLog/index";
import Layout from "../../components/layout";
import AntRadioLarge from "../../components/antRadioLarge";
import loginService from "../../service/login";
import { checkUrl } from "../../constants/constants";
import { setPopup } from "../../actions/popupAction";

import { MainLogIcon } from "../../assets/svg";
import MobileHeader from "../../components/header/mobileHeader";
import "./styles.scss";

const Logs = () => {
  const history = useHistory();

  const [state, setState] = useState({
    activeTab: "livechat",
    loading: false,
  });

  const toggle = (tab) => {
    setState((st) => ({
      ...st,
      activeTab: tab,
      optionSelected: true,
    }));

    history.push({
      search: `?tab=${tab}`,
    });
  };

  const checkTokenStatus = async () => {
    const token = loginService.getToken();

    if (!token) {
      history.push("/login");
    }

    const user = loginService.getDecodedToken().payload;

    if (!user.liveChatAccess && !user.broadcastAccess) {
      checkUrl(user, history);
    }
  };

  useEffect(() => {
    checkTokenStatus();
  }, []);

  useEffect(() => {
    const { liveChatAccess } = loginService.getUser();
    const activeTab = !liveChatAccess ? "broadcast" : "livechat";
    setState((st) => ({
      ...st,
      activeTab,
      optionSelected: true,
    }));
  }, []);

  const options = () => {
    const { broadcastAccess, liveChatAccess } = loginService.getUser();
    const values = [
      { name: "Live Chat", value: "livechat" },
      { name: "Broadcast", value: "broadcast" },
    ];
    if (liveChatAccess && broadcastAccess) {
      return values;
    } else if (liveChatAccess) {
      return [values[0]];
    } else {
      return [values[1]];
    }
  };
  const { activeTab } = state;

  return (
    <>
      <Layout testId="broadcast-main-page-wrapper">
      <div className="display-in-mob">
        <MobileHeader
          showLogo={false}
          showBackButton={true}
          showPageTitle={true}
          pageTitle="Logs"
          showNotifications={false}
          showHelp={false}
          showAccountDetails={false}
          handleBackButton={() => {
            history.push("/");
          }}
        />
      </div>
      <div className="inner-content-wrapper logs-wrapper">
        <Card
          className="primary-card logs-card"
          title={
            <span className="logs-custom-header">
              <p className="heading ">
                <MainLogIcon />
                &nbsp; Logs
              </p>
              <>
                <AntRadioLarge
                  options={options()}
                  value={activeTab}
                  handleChange={(e) => toggle(e.target.value)}
                />
              </>
            </span>
          }
        >
          <div className="logs-main-container">
            <>
              {activeTab === "livechat" ? <LivechatLog /> : null}
              {activeTab === "broadcast" ? <BroadcastLog /> : null}
            </>
          </div>
        </Card>
      </div>
      </Layout>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(Logs);
